import { createRouter, createWebHistory } from 'vue-router'
import DeviceLayout from '../views/device/Device.vue'
import PageView from '../views/device/PageView.vue'
import DetailPage from '../views/device/DetailPage.vue'
import ApiSearchView from '../views/device/ApiSearchView.vue'
import AdminLayout from '../views/admin/AdminLayout.vue'
import CrawlConfigView from '../views/admin/CrawlConfigView.vue'
import ImportView from '../views/admin/ImportView.vue'
import StatisticsView from '../views/admin/StatisticsView.vue'
import { getPharmaAiToken, redirectToSso, shouldBypassSso } from '../utils/auth'

const routes = [
  {
    path: '/',
    redirect: '/dashboard/1'
  },
  {
    path: '/dashboard',
    component: DeviceLayout,
    children: [
      {
        path: 'api',
        name: 'ApiSearch',
        component: ApiSearchView,
      },
      {
        path: ':labelGroup',
        name: 'Dashboard',
        component: PageView,
        props: true
      },
      {
        path: ':labelGroup/detail/:id',
        name: 'Detail',
        component: DetailPage,
        props: true
      }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/crawlconfig',
    children: [
      { path: 'crawlconfig', name: 'AdminCrawlConfig', component: CrawlConfigView },
      { path: 'import', name: 'AdminImport', component: ImportView },
      { path: 'statistics', name: 'AdminStatistics', component: StatisticsView },
      { path: 'pageconfig', redirect: '/admin/crawlconfig' },
      { path: 'api', redirect: '/dashboard/api' },
      { path: 'export', redirect: '/admin/crawlconfig' },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // yousui 测试域等：直接放行，不校验 token / 不跳 SSO
  if (shouldBypassSso()) {
    next()
    return
  }
  if (!getPharmaAiToken()) {
    if (redirectToSso()) {
      next(false)
      return
    }
  }
  next()
})

export default router
